import { createStore, applyMiddleware, compose } from 'redux';
import getConfig from 'next/config';
import customThunk from './customThunk';
import analyticsMiddleware from './AnalyticsMiddleware';
import Middleware from './Middleware';
import appBridgeMiddleware from './app-bridge/AppBridgeMiddleware.ts';
import reducer from '../reducers/index';

const { publicRuntimeConfig } = getConfig();

export default function configureStore(initialState) {
  const composeEnhancers =
    (publicRuntimeConfig.nodeEnv !== 'production' &&
      typeof window === 'object' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  const finalCreateStore = composeEnhancers(
    applyMiddleware(customThunk),
    applyMiddleware(analyticsMiddleware),
    applyMiddleware(Middleware),
    applyMiddleware(appBridgeMiddleware),
    f => f
  )(createStore);

  const store = finalCreateStore(reducer, initialState);

  if (publicRuntimeConfig.nodeEnv === 'development') {
    if (module.hot) {
      // Enable Webpack hot module replacement for reducers
      module.hot.accept('../reducers', () => {
        const nextReducer = require('../reducers');
        store.replaceReducer(nextReducer);
      });
    }
  }

  return store;
}
